import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32f61401"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "metadata-input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title contents-title" }, "メタデータを入力", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "入力いただいた内容は、当館のメタデータ作成ルールに基づき修正する場合があります。当館が作成・公開したメタデータの修正依頼には原則対応しておりませんので、予めご承知おきください。", -1))
const _hoisted_4 = { class: "navigation" }
const _hoisted_5 = { class: "navigation-button" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 戻る ", -1))
const _hoisted_7 = { class: "navigation-button" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 進む ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MetadataInput = _resolveComponent("MetadataInput")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_MetadataInput, {
        modelValue: _ctx.metadataList,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.metadataList) = $event)),
        requiredCheck: _ctx.requiredCheck,
        "onUpdate:requiredCheck": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requiredCheck) = $event))
      }, null, 8, ["modelValue", "requiredCheck"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.prev,
          onKeydown: _withKeys(_withModifiers(_ctx.prev, ["prevent"]), ["space","enter"]),
          buttonId: 'button-back'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DssIcon, {
              icon: "arrow-left",
              style: {"font-size":"18px"}
            }),
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.next,
          onKeydown: _withKeys(_withModifiers(_ctx.next, ["prevent"]), ["space","enter"]),
          styled: 'is-accent',
          buttonId: 'button-next',
          disabled: !_ctx.metadataList
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createVNode(_component_DssIcon, {
              icon: "arrow-right",
              style: {"font-size":"18px"}
            })
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown", "disabled"])
      ])
    ])
  ], 64))
}